import { createSelector } from '@ngrx/store';
import { Pricing } from '@shared/core/utils';

import { getReorder } from '../getReorder';

export const reorderSelectedItemsTotalValue = (orderGUID: string, locationNo: number, pickupTime: OLO.Ordering.PickupTime) =>
    createSelector(getReorder(orderGUID, locationNo, pickupTime), (foundReorder) => {
        if (!foundReorder || !foundReorder.data || !foundReorder.data.cart) return 0;

        let menuFlowsTotal: number = 0;
        for (let i = 0, j = foundReorder.data.cart.itemsMenuFlow.length; i < j; i++) {
            const menuFlow = foundReorder.data.cart.itemsMenuFlow[i];
            const extraPrice = Pricing.calculateExtraPriceForIngredients(menuFlow);
            if (menuFlow._IsSelected && !menuFlow._IsDisabled) {
                menuFlowsTotal += (menuFlow.UnitTotalValue + extraPrice) * menuFlow.Quantity || 0;
            }
        }

        let simpleItemsTotal: number = 0;
        for (let i = 0, j = foundReorder.data.cart.itemsSimple.length; i < j; i++) {
            let simpleItem = foundReorder.data.cart.itemsSimple[i];
            if (simpleItem._IsSelected && !simpleItem._IsDisabled) {
                simpleItemsTotal += simpleItem.UnitPrice * simpleItem.Quantity;
            }
        }

        return menuFlowsTotal + simpleItemsTotal;
    });
